import React from "react";
import PropTypes from "prop-types";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import { useTheme } from "../../theme/ThemeProvider";

const PageHeader = ({ title, breadcrumbItems, currentPage }) => {
  const { isDarkMode } = useTheme();

  return (
    <div 
      className={`flex justify-center min-h-[150px] md:min-h-[250px] w-full transition-colors duration-200 ${
        isDarkMode 
          ? "bg-gray-800 bg-opacity-80" 
          : "bg-slate-200 page-header-banner"
      }`}
    >
      <div className="relative flex flex-col items-center justify-center w-full px-4">
        <h2 className="text-xl md:text-2xl lg:text-3xl 2xl:text-[32px] font-bold text-center">
          <span 
            className={`block mb-3 font-bold md:mb-4 lg:mb-5 2xl:mb-7 transition-colors duration-200 ${
              isDarkMode ? "text-white" : "text-brand-dark"
            }`}
          >
            {title}
          </span>
        </h2>
        <Breadcrumb items={breadcrumbItems} currentPage={currentPage} />
      </div>
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  breadcrumbItems: PropTypes.array.isRequired,
  currentPage: PropTypes.object
};

export default PageHeader;